import * as React from 'react';

import IMPComponent from '../interfaces/IMPComponent';

import { CSSProperties } from 'react';
import styled from 'styled-components';

export interface IProgressBarProps extends IMPComponent {
  expectedWordsCount: number;
  actualWordsCount: number;
}

const ProgressBarIndicator = styled.div`
  background-color: ${p => p.theme.color.greenBlue};
  height: 0.2em;
  max-width: 100%;
`;

const ProgressBarBackground = styled.div`
  background-color: ${p => p.theme.color.borderColor};
  height: 0.2em;
  max-width: 100%;
`;

const ProgressBar = (props: IProgressBarProps) => {
  const progressBarStyle: CSSProperties = {
    width: `${(props.actualWordsCount / props.expectedWordsCount) * 100}%`,
  };

  return (
    <ProgressBarBackground>
      <ProgressBarIndicator style={progressBarStyle} />
    </ProgressBarBackground>
  );
};

export default React.memo(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.tsx